<!--
 * @Author: qinzhenpen qzp1807@126.com
 * @Date: 2023-09-28 14:48:30
 * @LastEditors: qinzhenpen qzp1807@126.com
 * @LastEditTime: 2025-07-28 14:49:26
 * @FilePath: \tianze_web\src\layout\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="app-wrapper" :class="{ 'is-standalone': isStandalone }">
    <div class="el-frame">
      <el-container v-if="userType != null">
        <el-header v-if="!isStandalone">
          <Navbar ref="navbar" @updateDate="updateDateNavbar"></Navbar>
        </el-header>
        <el-container class="bodyContainer">
          <el-aside v-if="!isStandalone">
            <Sidebar ref="sidebar" @updateDate="updateDateNavbar"></Sidebar>
          </el-aside>
          <el-main>
            <AppMain></AppMain>
          </el-main>
        </el-container>
          <el-footer class="tz-footer" height="40px" v-if="!isStandalone">
            <span>智云教学平台系统 V1.0 &nbsp;&nbsp;粤ICP备17143346号</span>
          </el-footer>
      </el-container>
      <div
        class="el-tooltip bgIcon"
        :class="{ zk: isExpand, col: updateFontColorBasedOnRoute($route.path) }"
        @click="showChatWindow"
        v-if="userType == 1 && !isStandalone"
      >
        <img
          src="../images/index/entranceIcon.f51a11a.png"
          ref="gifImage"
          alt=""
          @mouseover="playGif"
          @mouseout="stopGif"
        />
        <span>AI数字人</span>
        <!-- <img src="@/assets/images/entranceHoverIcon.97656b9.gif" alt="" /> -->
      </div>
      <div class="chatWindow" v-if="chatWindow">
        <div class="menuTop">
          <div
            class="backPage"
            v-if="status == '历史对话'"
            @click="(status = '对话'), gInterrupt()"
          >
            <img
              style="width: 1.5em; height: 1.5em"
              src="../images/index/返回箭头.png"
              alt=""
            />
          </div>
          <div class="menuTitle" v-if="status == '历史对话'">历史对话</div>
          <div class="tabMenuUi" v-if="status !== '历史对话'">
            <span>对话</span>
          </div>
          <div class="menuBtn">
            <img
              src="../images/index/添加.png"
              alt=""
              @click="addNewConversation"
              v-if="status !== '历史对话'"
            />
            <img
              src="../images/index/历史.png"
              alt=""
              v-if="status !== '历史对话'"
              @click="getHistorysdata('历史对话')"
            />
            <img
              src="../images/index/删除.png"
              alt=""
              @click="gCloseTheConversation"
            />
          </div>
        </div>
        <template v-if="status == '对话'">
          <div class="conversationArea">
            <div class="conversaHead">
              <img src="../images/index/favicon.png" alt="" />
              <span>小天</span>
            </div>
            <div class="conversaScroll" ref="scrollArea">
              <div class="assistantDes">
                我可以回答课程知识点、内容、操作流程、产业、政策、就业和岗位相关的问题，以帮助您更好地了解和掌握相关信息。
              </div>
              <div class="assistantQuestion" v-if="messages.length == 0">
                <p>你可以试着问我：</p>
                <ul>
                  <li @click="send('公司金融核心内容原理是什么?')">
                    公司金融核心内容原理是什么?
                  </li>
                  <li @click="send('AI时代金融公司有那些变化?')">
                    AI时代金融公司有那些变化?
                  </li>
                  <li @click="send('金融科技下公司金融相关业务发展放下')">
                    金融科技下公司金融相关业务发展
                  </li>
                </ul>
              </div>
              <div class="creatQuestionTime"></div>
              <ul class="QAlist">
                <li
                  :class="[item.role == 'user' ? 'questionItem' : 'answerItem']"
                  v-for="item in messages"
                  :key="item"
                >
                  <div
                    :class="[item.role == 'user' ? 'qustionCon' : 'answerCon']"
                  >
                    <mavon-editor
                      v-model="item.content"
                      :toolbarsFlag="false"
                      :subfield="false"
                      defaultOpen="preview"
                      class="auto-height"
                    />
                  </div>
                </li>
                <li
                  v-if="isRequestPending"
                  style="height: 68px"
                  v-loading="isRequestPending"
                  :element-loading-svg="svg"
                ></li>
              </ul>
            </div>
          </div>
          <div class="bottomPrompter">
            <div class="prompter">
              <div class="prompterDiv">
                <el-input
                  v-model="inputMessage"
                  @keyup.enter.native="sendMessage"
                  @input="checkLength"
                >
                  <template #suffix>
                    <img
                      style="width: 1.5em; height: 1.5em; line-height: 40px"
                      src="../images/index/发送.png"
                      alt=""
                      @click="sendMessage"
                      v-if="isTypingComplete"
                    />
                    <img
                      style="width: 1.5em; height: 1.5em; line-height: 40px"
                      src="../images/index/中断.png"
                      alt=""
                      @click="gInterrupt"
                      v-else
                    />
                    <!-- <svg-icon icon-class="fs" style="width: 1.5em; height: 1.5em" @click="sendMessage" v-if="isTypingComplete" /> -->
                    <!-- <svg-icon icon-class="中断" style="width: 1.5em; height: 1.5em" @click="gInterrupt" v-else /> -->
                  </template>
                </el-input>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <ul class="historyList">
            <template v-for="item in historyList">
              <li :key="item">
                <div class="historyItem">
                  <img
                    src="data:image/png;base64,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"
                    alt=""
                  />
                  <div>
                    <p>小天</p>
                    <span>{{ formatDate(item.createTime) }}</span>
                  </div>
                  <p class="enterBtn mr10" @click="gHistoricalDetails(item)">
                    打开
                  </p>
                  <p class="enterBtn enterBtn1" @click="del(item)">删除</p>
                </div>
                <div class="historyDes">
                  <span v-html="item.content"></span>
                </div>
              </li>
            </template>
            <li v-if="!historyList.length">
              <el-empty description="暂无历史对话" :image-size="30" />
            </li>
          </ul>
        </template>
      </div>
      <div class="zd" @click="expand" v-if="userType == 1">
        <el-tooltip
          class="item"
          effect="dark"
          content="AI数字人"
          placement="top"
        >
          <img
            src="../images/index/收起.png"
            alt=""
            :class="{ zd1: isExpand }"
          />
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from "./components";
import { mavonEditor } from "mavon-editor";
import "mavon-editor/dist/css/index.css";
export default {
  name: "Layout",
  components: {
    Navbar,
    Sidebar,
    AppMain,
    "mavon-editor": mavonEditor,
  },
  data() {
    return {
      content: "# 你好，Markdown\n\n这是 **加粗**，这是 *斜体*。",
      maxLength: 300,
      identityInfo: this.$ls.get(this.$getKeyInfo("identityInfo")) || {},
      userType: null,
      scrollArea: null,
      isRequestPending: false,
      inputMessage: "",
      historyList: [],
      status: "对话",
      proxy: this,
      gifImage: null,
      chatWindow: false,
      messages: [],
      isTypingComplete: true,
      abortController: null,
      isExpand: false,
    };
  },
  computed: {
    // 预防userInfo为空
    userInfos() {
      return this.identityInfo || {};
    },
    // 双屏演示模式：副屏独立窗口不渲染导航/侧边栏/页脚，只保留内容区
    isStandalone() {
      return this.$route.query.standalone == 1;
    },
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      if (!this.$isEmpty(this.$getToken())) {
        this.$post("/api/base/userInfo.do").then((ret) => {
          if (ret.code == 0) {
            if (ret.data.coreUser.jobType1 == "JT_S_02") {
              //判断用户类型 JT_S_03：学生 JT_S_02：教师
              this.userType = 2;
            } else if (ret.data.coreUser.jobType1 == "JT_S_03") {
              this.userType = 1;
            }
            this.$ls.set(
              this.$getKeyInfo("userType"),
              this.$Base64.encode(this.userType)
            ); //写入用户类型
            this.$ls.set(this.$getKeyInfo("userInfo"), ret.data.coreUser);
            this.$ls.set(
              this.$getKeyInfo("identityInfo"),
              ret.data.identityInfo
            );
          }
        });
      }
    },
    formatDate(cellValue) {
      if (cellValue == null || cellValue == "") return "";
      var date = new Date(cellValue);
      var year = date.getFullYear();
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
    // 滚动到底部的函数
    scrollToBottom() {
      const scrollEl = this.$refs.scrollArea;
      if (scrollEl) {
        scrollEl.scrollTop = scrollEl.scrollHeight;
      }
    },
    updateDateNavbar(val) {
      if (val == "navbar") {
        this.$refs.sidebar.onIndex = null;
      }
      if (val == "sidebar") {
        this.$refs.navbar.onIndex = null;
      }
    },
    showChatWindow() {
      this.chatWindow = !this.chatWindow;

      this.identityInfo = this.$ls.get(this.$getKeyInfo("identityInfo")) || {};
      if (this.chatWindow) {
        if (sessionStorage.getItem("AI-uuid")) {
          this.getHistorys();
          return;
        }
        this.gHistoricalRecords();
      }
    },
    // 鼠标移入
    playGif() {
      if (this.$refs.gifImage) {
        this.$refs.gifImage.src = require(`../images/index/entranceHoverIcon.97656b9.gif`);
      }
    },
    // 移除
    stopGif() {
      if (this.$refs.gifImage) {
        this.$refs.gifImage.src = require(`../images/index/entranceIcon.f51a11a.png`);
      }
    },
    // 中断对话
    gInterrupt() {
      if (this.abortController) {
        this.abortController.abort();
        this.isRequestPending = false;
        this.isTypingComplete = true;
      }
    },
    // 创建会话
    addhh() {
      this.$posts("https://whmnjy.sztzjy.com:8764/api/createSession", {
        systemOwner: "天择智云",
        userId: this.userInfos.userId,
      }).then((ret) => {
        this.messages = [];
        sessionStorage.removeItem("AI-uuid");
        sessionStorage.setItem("AI-uuid", ret);
      });
    },
    // 新增会话
    addNewConversation() {
      if (this.messages.length <= 0) {
        this.$message.warning("当前已是最新对话!");
        return;
      }
      this.addhh();
    },
    getHistorysdata(val) {
      this.status = val;
      this.gInterrupt();
      this.gHistoricalRecords();
    },
    // 删除
    del(val) {
      this.$posts("https://whmnjy.sztzjy.com:8764/api/deleteSession", {
        sessionId: val.sessionId,
      }).then((ret) => {
        this.$message.success("删除成功");
        this.gHistoricalRecords();
      });
    },
    // 查询历史记录
    gHistoricalRecords() {
      this.$posts("https://whmnjy.sztzjy.com:8764/api/selectSessionList", {
        systemOwner: "天择智云",
        userId: this.userInfos.userId,
      }).then((ret) => {
        this.historyList = ret;
        if (this.historyList.length > 0) {
          sessionStorage.removeItem("AI-uuid");
          sessionStorage.setItem("AI-uuid", this.historyList[0].sessionId);
          this.getHistorys();
        } else {
          this.addhh();
        }
      });
    },
    // 关闭
    gCloseTheConversation() {
      this.chatWindow = false;
      sessionStorage.removeItem("AI-uuid");
      this.gInterrupt();
    },
    gHistoricalDetails(val) {
      sessionStorage.removeItem("AI-uuid");
      sessionStorage.setItem("AI-uuid", val.sessionId);
      this.status = "对话";
      this.getHistorys();
    },
    getHistorys() {
      if (!sessionStorage.getItem("AI-uuid")) return;
      this.$posts("https://whmnjy.sztzjy.com:8764/api/selectHistory", {
        sessionId: sessionStorage.getItem("AI-uuid"),
      }).then((ret) => {
        if (ret.length > 0) {
          sessionStorage.removeItem("AI-uuid");
          sessionStorage.setItem("AI-uuid", ret[0].sessionId);
          this.messages = ret;
          this.scrollToBottom();
        }
      });
    },
    async sendMessage() {
      if (!this.inputMessage.trim() || this.isRequestPending) return;
      this.isRequestPending = true;
      this.isTypingComplete = true;
      this.messages.push({
        id: Date.now(),
        role: "user",
        content: this.inputMessage,
      });
      this.$nextTick(() => {
        this.scrollToBottom();
        this.inputMessage = "";
      });
      this.abortController = new AbortController();
      const signal = this.abortController.signal;
      let params = {
        systemOwner: "天择智云",
        userId: this.userInfos.userId,
        sessionId: sessionStorage.getItem("AI-uuid"),
        type:'1'
      };
      this.isTypingComplete = false;
      const queryString = new URLSearchParams(params).toString();
      const resp = await fetch(
        `https://whmnjy.sztzjy.com:8764/api/kimi4?${queryString}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: this.inputMessage.trim(),
          signal,
        }
      );
      // 添加AI消息占位
      const newMessage = { id: Date.now(), role: "assistant", content: "" };
      this.messages.push(newMessage);
      const reader = resp.body.getReader();
      const decoder = new TextDecoder("utf-8");
      while (true) {
        const { done, value } = await reader.read();
        this.isRequestPending = false;
        if (done) break;
        const text = decoder.decode(value, { stream: true });
        await this.typeText(newMessage, text);
        //滚动到最新消息
        this.$nextTick(() => {
          const scrollEl = document.querySelector(".conversaScroll");
          scrollEl.scrollTop = scrollEl.scrollHeight;
        });
      }
    },
    // 其他方法保持不变...
    typeText(message, text) {
       return new Promise(resolve => {
        this.isTypingComplete = false; // 重置状态
        let index = 0;
        message.content = ""; // 清空原内容
        const textLength = text.length;
        const chunkSize = textLength > 100 ? 3 : 1; // 根据文本长度动态调整批量字数
        const typingSpeed = textLength > 100 ? 30 : 60; // 适配长短文本
        const interval = setInterval(() => {
            if (index < text.length) {
                message.content += text.slice(index, index + chunkSize);
                index += chunkSize;
                if (index % 10 === 0)  this.$nextTick(() => this.scrollToBottom()); // 限制滚动更新频率
            } else {
                clearInterval(interval);
                this.isTypingComplete = true;
                console.log('输出完成');
                this.$nextTick(() => this.scrollToBottom());
                resolve();
            }
        }, typingSpeed);
    });
    },
    send(val) {
      this.inputMessage = val;
      this.sendMessage();
    },
    checkLength(value) {
      if (value.length > this.maxLength) {
        this.inputMessage = value.slice(0, this.maxLength);
        this.$message.warning(`输入内容不能超过${this.maxLength}个字符`);
      }
    },
    expand() {
      this.isExpand = !this.isExpand;
      if (this.isExpand) {
        this.chatWindow = false;
      }
    },
    updateFontColorBasedOnRoute(path) {
      if (path === "/myAppsCenter") {
        return true;
      } else if (path === "/myAppsDetails2") {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="less">
@import "../static/iconfont/iconfont.css";
@import "../styles/style.less";
@import "../styles/base.less";
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-width: 1536px;
}
.el-header
 {
  background-color: @bgZS;
  line-height: 95px;
  height: 95px !important;
  .logo {
    margin: 0 30px;
  }
  .logo img {
    height: 60px;
    width: auto;
    margin-top: 18px;
    max-width: 100%;
  }
}
.bodyContainer {
  height: calc(100vh - 195px);
  .el-menu-vertical-demo {
    height: calc(100vh - 178px);
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    overflow: auto;
    border-right: none;
  }
  .el-menu-vertical-demo::-webkit-scrollbar {
    display: none;
  }
  .el-aside {
    height: calc(100vh - 95px);
    overflow: auto;
    padding: 0;
    margin: 0;
    background-color: @bgZS;
    width: 88px !important;
    ul {
      list-style-type: none;
      color: #ffffff;
      margin: 0;
      padding: 0;
      li {
        padding: 20px 0;
        text-align: center;
        span {
          display: block;
        }
        .iconfont {
          display: initial;
          font-size: 30px;
        }
        a {
          color: white;
          text-decoration-line: none;
        }
      }
      .on {
        background-color: #3979b8;
        color: #ffffff !important;
      }
      li:hover {
        background-color: #3979b8;
        cursor: pointer;
      }
    }
  }
  .el-main {
    height: calc(100vh - 130px) !important;
    overflow: auto;
  }
  .menu_img {
    width: 44px;
    height: 44px;
    border-radius: 50%;
  }
}
.headerContainer {
  ul {
    list-style-type: none;
    color: #ffffff;
    margin: 0;
    padding: 0;
  }
  li {
    float: left;
  }
  .menu_img {
    width: 46px;
    height: 46px;
    float: left;
    border-radius: 50%;
  }
  a {
    float: left;
    margin-top: 25px;
    color: white;
    text-decoration-line: none;
  }
  span {
    float: left;
    line-height: 50px;
    // margin: 0 40px 0 18px;
    text-align: center;
    min-width: 100px;
    max-width: 110px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    /*! autoprefixer: off */
    -webkit-box-orient: vertical;
    /* autoprefixer: on */
  }
  .el-dropdown {
    margin-top: 25px;
  }
}

.el-aside::-webkit-scrollbar {
  display: none;
}
.el-main {
  background-color: @mainBg;
  min-width: 800px;
  // height: calc(100vh - 80px);
  // overflow: auto;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
.odyContainer {
  height: calc(100vh - 77px);
}
//右侧页面下拉隐藏
.page_content::-webkit-scrollbar {
  display: none;
}
.el-menu-item-group__title {
  padding: 0;
}
.el-menu-item,
.el-submenu__title {
  font-size: 17px;
  border-bottom: 1px solid #f3f3f3 !important;
}
.el-submenu .el-menu-item {
  padding-left: 60px !important;
  height: 56px;
  line-height: 56px;
}
.iconfont {
  margin: 0 5px;
  width: 24px;
  text-align: center;
  font-size: 24px;
  vertical-align: middle;
}

.el-main {
  padding: 0;
}
//宽度小于等于
@media screen and (max-width: 1617px) {
  .el-header {
    line-height: 65px;
    height: 65px !important;
    .logo img {
      height: 40px;
      width: auto;
      margin-top: 12px;
    }
  }
  .bodyContainer {
    .el-menu-vertical-demo {
      height: calc(100vh - 178px);
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      overflow: auto;
      border-right: none;
    }
    .el-menu-vertical-demo::-webkit-scrollbar {
      display: none;
    }
    .el-aside {
      height: calc(100vh - 65px);
      overflow: auto;
      padding: 0;
      margin: 0;
      background-color: @bgZS;
      width: 68px !important;
      ul {
        li {
          padding: 20px 0;
          text-align: center;
          a {
            color: white;
            text-decoration-line: none;
            font-size: 12px;
          }
        }
        .on {
          background-color: #3979b8;
          color: #ffffff !important;
        }
        li:hover {
          background-color: #3979b8;
          cursor: pointer;
        }
      }
    }
    .el-main {
      height: calc(100vh - 65px) !important;
      overflow: auto;
    }
    .menu_img {
      width: 34px;
      height: 34px;
      border-radius: 50%;
    }
  }
  .headerContainer {
    ul {
      list-style-type: none;
      color: #ffffff;
      margin: 0;
      padding: 0;
    }
    li {
      float: left;
    }
    .menu_img {
      width: 34px;
      height: 34px;
      float: left;
      border-radius: 50%;
    }
    a {
      float: left;
      margin-top: 15px;
      color: white;
      text-decoration-line: none;
      font-size: 14px;
    }
    span {
      float: left;
      line-height: 40px;
      // margin: 0 30px 0 20px;
      min-width: 90px;
      text-align: center;
    }
    .el-dropdown {
      margin-top: 10px;
      color: white;
      span {
        line-height: 50px;
      }
    }
  }
}
.chatWindow {
  position: fixed;
  bottom: 30px;
  right: 215px;
  height: 70%;
  max-height: 800px;
  width: 375px;
  background: #f2f9fd;
  -webkit-box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  z-index: 200;

  // display: none;
  .menuTop {
    height: 52px;
    line-height: 52px;
    background: linear-gradient(228deg, #2fb0ff, #5466ff);
    border-radius: 12px 12px 0 0;
    color: #fff;
    .backPage {
      float: left;
      line-height: 66px;
      padding-left: 10px;
      cursor: pointer;
      .el-icon {
        font-size: 20px;
        margin-top: 16px;
        cursor: pointer;
      }
    }
    .menuTitle {
      font-size: 18px;
      position: absolute;
      left: 50%;
      font-weight: normal;
      transform: translateX(-50%);
    }
    .tabMenuUi {
      padding-left: 10px;
      span {
        font-size: 18px;
        font-weight: 500;
      }
      float: left;
    }
    .menuBtn {
      float: right;
      img {
        width: 1.5em;
        height: 1.5em;
        vertical-align: -7px;
        margin-right: 16px;
        cursor: pointer !important;
      }
    }
  }
  .conversationArea {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    padding: 16px 0 0 12px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    overflow: hidden;
    ul {
      list-style-type: none;
      padding: 0;
    }
    .conversaHead {
      overflow: hidden;
      img {
        height: 32px;
        float: left;
        margin-right: 8px;
        background: white;
        width: 40px;
        padding: 3px;
      }
      span {
        line-height: 32px;
        font-size: 14px;
        color: #333;
        font-weight: 500;
      }
    }
    .conversaScroll {
      -webkit-box-flex: 1;
      -ms-flex: 1;
      flex: 1;
      overflow: auto;
      padding-right: 12px;
      .assistantDes {
        background: #fff;
        border-radius: 12px 12px 12px 0;
        border: 1px solid #d4dfff;
        font-size: 14px;
        color: #444;
        line-height: 22px;
        padding: 10px 16px 10px 12px;
        margin-top: 6px;
      }
      .assistantQuestion {
        margin-top: 10px;
        padding: 12px 16px 16px 12px;
        p {
          margin: 0;
          padding: 0;
          font-size: 14px;
          color: #444;
          line-height: 22px;
        }
        ul {
          li {
            margin-top: 10px;
            background: #fff;
            border-radius: 12px 12px 12px 0;
            border: 1px solid #d4dfff;
            padding: 12px 16px 16px 12px;
            font-size: 14px;
            color: #444;
            // 鼠标小手
            cursor: pointer;
            line-height: 22px;
            &:hover {
              background: #f0f5ff;
            }
          }
        }
      }
      .creatQuestionTime {
        font-size: 13px;
        color: #999;
        line-height: 18px;
        text-align: center;
        margin-top: 15px;
      }
      .QAlist {
        li {
          display: flex !important;
          overflow: hidden;
          margin-bottom: 12px;
          .el-loading-mask {
            background: transparent !important;
          }
        }
        .auto-height {
          height: auto !important;
          min-height: 100px;
          overflow: visible;
        }
        .questionItem {
          // display: flex;
          justify-content: flex-end;
          .qustionCon {
            background: #5481ed;
            border-radius: 12px 12px 0 12px;
            // padding: 0px 12px 0px 16px;
            font-weight: 400;
            font-size: 14px;
            color: #fff;
            line-height: 20px;
            max-width: calc(100% - 51px);
            word-break: break-all;
            .v-note-wrapper {
              --md-color: #fff;
              --md-bk-color: transparent;
              min-width: 0px !important;
              min-height: 0px !important;
              .v-show-content {
                padding: 8px 10px 8px 10px;
                background: #5481ed !important;
                border-radius: 12px 12px 0 12px;
                // padding: 0px 12px 0px 16px;
                font-weight: 400;
                font-size: 14px;
                color: #fff;
                line-height: 20px;
                word-break: break-all;
              }
              p {
                margin: 0px;
              }
            }
          }
        }
        .answerItem {
          display: flex;
          margin-bottom: 12px;
          overflow: hidden;
          .answerCon {
            -webkit-box-flex: 1;
            font-weight: 400;
            font-size: 14px;
            color: rgb(68, 68, 68);
            line-height: 22px;
            width: calc(100% - 51px);
            word-break: break-all;
            flex: 1 1 0%;
            background: rgb(255, 255, 255);
            border-radius: 12px 12px 12px 0px;
            border-width: 1px;
            border-style: solid;
            border-color: rgb(212, 223, 255);
            border-image: initial;
            .v-note-wrapper {
              min-height: 0;
              .v-note-show {
                background: #f2f9fd !important;
              }
              .v-show-content {
                font-weight: 400;
                font-size: 14px;
                color: rgb(68, 68, 68);
                // line-height: px;
                word-break: break-all;
                flex: 1 1 0%;
                background: rgb(255, 255, 255) !important;
                border-radius: 12px 12px 12px 0px !important;
                border-width: 1px;
                border-style: solid !important;
                border-color: rgb(212, 223, 255) !important;
                border-image: initial;
              }
              p {
                margin: 0px;
              }
            }
            // padding: 0px 16px 0px 16px;
          }
        }
        margin-top: 10px;
      }
    }
  }
  .bottomPrompter {
    min-height: 80px;
    padding: 20px 12px 20px 18px;
    .prompterDiv {
      display: flex;
      .el-input {
        flex: 1;
        background: #fff;
        border-radius: 22px;
        border: 1px solid #5f87ff;
        display: flex;
        padding: 5px 10px;
        .el-input__inner {
          border: none !important;
          color: #333;
        }
        .el-input__suffix {
          cursor: pointer;
          display: flex !important;
          align-items: center !important;
          right: 15px !important;
        }
      }
    }
  }
  .historyList {
    height: calc(100% - 52px);
    padding: 16px 12px;
    overflow: auto;
    list-style-type: none;
    margin: 0;
    li {
      background: #fff;
      -webkit-box-shadow: 0 1px 4px 0 rgba(0, 61, 208, 0.15);
      box-shadow: 0 1px 4px 0 rgba(0, 61, 208, 0.15);
      border-radius: 8px;
      padding: 12px;
      margin-bottom: 10px;
      .historyItem {
        display: flex;
        img {
          width: 40px;
          height: 40px;
          margin-right: 8px;
        }
        & > div {
          flex: 1;
          p {
            margin: 0;
            font-size: 14px;
            color: #333;
            line-height: 20px;
          }
          span {
            font-size: 12px;
            color: #555;
            line-height: 17px;
          }
        }
        .enterBtn {
          width: 60px;
          height: 30px;
          line-height: 30px;
          background: -webkit-gradient(
            linear,
            right top,
            left top,
            from(#4c74ed),
            to(#2fb0ff)
          );
          background: linear-gradient(270deg, #4c74ed, #2fb0ff);
          border-radius: 16px;
          text-align: center;
          font-weight: 400;
          font-size: 13px;
          color: #fff;
          cursor: pointer;
        }
        .enterBtn1 {
          background: red;
          color: #f0f5ff;
        }
      }
      .historyDes {
      }
    }
  }
}
.bgIcon {
  position: fixed;
  bottom: 180px;
  right: 40px;
  cursor: pointer;
  z-index: 300;
  display: flex;
  flex-direction: column;
  align-items: center;
  display: block;
  img {
    width: 167px;
    height: 181px;
  }
  span {
    color: #333333 !important;
    display: block;
    text-align: center;
  }
}
.col {
  span {
    color: #ffffff !important;
    font-weight: normal;
    // 文字饱满度
    font-stretch: normal;
    // 文字间隔
    letter-spacing: 2px;
  }
}
.zd {
  position: fixed;
  bottom: 268px;
  right: 28px;
  cursor: pointer;
  z-index: 300;
  width: 30px;
  height: 30px;
  img {
    width: 100%;
    height: 100%;
    transform: rotate(-90deg);
    transition: transform 0.5s;
  }
  .zd1 {
    transform: rotate(90deg);
    // 动画效果
    transition: transform 0.5s;
  }
}
.zk {
  // 折叠效果
  display: none;
}
.tz-footer{
  position: absolute;
  bottom: 0;
  left:88px;
  width: calc(100% - 88px);
  height: 40px !important;
  text-align: center;
    padding: 10px 0;
    background-color: #0263d3;
    color: #fff;
    font-size: 1rem;
}
// 双屏演示（standalone=1）：副屏窗口铺满、去掉内容区留白
.app-wrapper.is-standalone {
  background-color: #ffffff;
  .el-main {
    padding: 0 !important;
    overflow: hidden;
  }
  .bodyContainer {
    height: 100vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue